<div class="bg-[#050A24] px-[1rem]">
  <div class="w-full max-w-[1400px]  flex justify-between mx-auto">
    <div class="justify-start items-center inline-flex">
      @if (_regionality.regionalityState$ | async; as state) {
      <button
        class="mr-8 max-[1210px]:mr-4 max-[1150px]:mr-1 justify-center items-center flex pr-2.5 border-0 city-selector-btn"
        (click)="openCityModal()"
      >
        <div class="flex items-center justify-center mr-1.5">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 1C6.54182 1.00165 5.14383 1.58165 4.11274 2.61274C3.08165 3.64383 2.50165 5.04182 2.5 6.5C2.5 11.2063 7.5 14.7606 7.71313 14.9094C7.7972 14.9683 7.89735 14.9999 8 14.9999C8.10265 14.9999 8.2028 14.9683 8.28687 14.9094C8.5 14.7606 13.5 11.2063 13.5 6.5C13.4983 5.04182 12.9184 3.64383 11.8873 2.61274C10.8562 1.58165 9.45818 1.00165 8 1ZM8 4.5C8.39556 4.5 8.78224 4.6173 9.11114 4.83706C9.44004 5.05682 9.69638 5.36918 9.84776 5.73463C9.99913 6.10009 10.0387 6.50222 9.96157 6.89018C9.8844 7.27814 9.69392 7.63451 9.41421 7.91421C9.13451 8.19392 8.77814 8.3844 8.39018 8.46157C8.00222 8.53874 7.60009 8.49914 7.23463 8.34776C6.86918 8.19638 6.55682 7.94004 6.33706 7.61114C6.1173 7.28224 6 6.89556 6 6.5C6 5.96957 6.21071 5.46086 6.58579 5.08579C6.96086 4.71071 7.46957 4.5 8 4.5Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="text-white text-sm font-normal">
          {{ state.city.name }}
        </div>
      </button>
      }
      <div class="mr-8 max-[1210px]:mr-4 max-[1150px]:mr-1 flex space-x-[5px]">
        <a
          href="https://rentag.ru/o-proekte"
          rel="nofollow"
          target="_blank"
          title="О сервисе"
          class="mr-[7px] text-white text-sm font-normal leading-tight p-2.5 transition-colors hover:bg-[#17233D] whitespace-nowrap"
          >О сервисе</a
        >
        <a
          href="https://rentag.ru/tarify"
          title="Тарифы"
          target="_blank"
          rel="nofollow"
          class="mr-[7px] text-white text-sm font-normal leading-tight p-2.5 transition-colors hover:bg-[#17233D] whitespace-nowrap"
          >Тарифы</a
        >
        <a
          href="https://rentag.ru/investoram"
          title="Инвесторам"
          target="_blank"
          class="mr-[7px] text-white text-sm font-normal leading-tight p-2.5 transition-colors hover:bg-[#17233D] whitespace-nowrap"
          rel="nofollow"
          >Инвесторам</a
        >
        <a
          title="Контакты"
          href="https://rentag.ru/kontakty"
          rel="nofollow"
          target="_blank"
          class="text-white text-sm font-normal leading-tight p-2.5 transition-colors hover:bg-[#17233D] whitespace-nowrap"
          >Контакты</a
        >
        <a
          title="Блог"
          href="https://rentag.ru/blog"
          target="_blank"
          rel="nofollow"
          class="text-white text-sm font-normal leading-tight p-2.5 transition-colors hover:bg-[#17233D] whitespace-nowrap"
          >Блог</a
        >
        <ra-another-links></ra-another-links>
      </div>
      <div class="mr-8 max-[1210px]:mr-4 max-[1150px]:mr-1 bg-gray-500 rounded-full w-1 h-1"></div>
      <ra-support-service
        [isDemo]="false"
        (openFeedbackModal)="openFeedbackModal($event)"
      ></ra-support-service>
    </div>

    <div class="inline-flex items-center">
      <a
        class="h-[26px] rounded-[4px] text-base inline-flex items-center px-2 bg-[#8B32B9] text-white transition-colors hover:bg-[#BA5BEA]"
        target="_blank"
        rel="noreferrer"
        href="https://rentag.ru/arenda-spectehniki/zayavki"
        >Биржа заявок</a
      >
<!--      <button-->
<!--        (click)="openFeedbackModal(9)"-->
<!--        class="border-none justify-start items-center inline-flex"-->
<!--      >-->
<!--        <svg-->
<!--          class="mr-2"-->
<!--          width="22"-->
<!--          height="21"-->
<!--          viewBox="0 0 22 21"-->
<!--          fill="none"-->
<!--          xmlns="http://www.w3.org/2000/svg"-->
<!--        >-->
<!--          <path-->
<!--            d="M11.6878 1.70951L13.8656 6.89951C13.9183 7.02547 14.0044 7.13464 14.1146 7.21526C14.2248 7.29589 14.3549 7.3449 14.4909 7.35701L20.0653 7.83889C20.2132 7.85077 20.3543 7.90627 20.4706 7.99835C20.587 8.09043 20.6734 8.21495 20.719 8.35616C20.7645 8.49738 20.7672 8.64893 20.7266 8.79166C20.686 8.93438 20.604 9.06185 20.4909 9.15795L16.2619 12.847C16.1591 12.9373 16.0827 13.0538 16.0407 13.184C15.9988 13.3142 15.9929 13.4534 16.0237 13.5867L17.2912 19.0748C17.3247 19.2182 17.3153 19.3682 17.2641 19.5062C17.213 19.6442 17.1223 19.7641 17.0035 19.851C16.8846 19.9379 16.7428 19.9878 16.5958 19.9947C16.4488 20.0015 16.303 19.965 16.1766 19.8895L11.3859 16.9833C11.2695 16.9125 11.1359 16.875 10.9997 16.875C10.8634 16.875 10.7298 16.9125 10.6134 16.9833L5.8228 19.8895C5.6964 19.965 5.55059 20.0015 5.40355 19.9947C5.25651 19.9878 5.11473 19.9379 4.99589 19.851C4.87704 19.7641 4.78639 19.6442 4.73522 19.5062C4.68404 19.3682 4.67462 19.2182 4.70811 19.0748L5.97561 13.5867C6.00642 13.4534 6.00055 13.3142 5.95863 13.184C5.9167 13.0538 5.84028 12.9373 5.73749 12.847L1.50843 9.15795C1.39536 9.06185 1.31335 8.93438 1.27275 8.79166C1.23216 8.64893 1.23481 8.49738 1.28038 8.35616C1.32594 8.21495 1.41237 8.09043 1.52873 7.99835C1.64509 7.90627 1.78615 7.85077 1.93405 7.83889L7.50843 7.35701C7.64443 7.3449 7.77454 7.29589 7.88474 7.21526C7.99493 7.13464 8.08103 7.02547 8.13374 6.89951L10.3116 1.70951C10.3697 1.57533 10.4658 1.46108 10.5881 1.38083C10.7104 1.30057 10.8534 1.25781 10.9997 1.25781C11.1459 1.25781 11.289 1.30057 11.4112 1.38083C11.5335 1.46108 11.6296 1.57533 11.6878 1.70951Z"-->
<!--            fill="url(#paint0_linear_6151_1836)"-->
<!--            stroke="url(#paint1_linear_6151_1836)"-->
<!--            stroke-width="2"-->
<!--            stroke-linecap="round"-->
<!--            stroke-linejoin="round"-->
<!--          />-->
<!--          <defs>-->
<!--            <linearGradient-->
<!--              id="paint0_linear_6151_1836"-->
<!--              x1="20.7552"-->
<!--              y1="19.9955"-->
<!--              x2="-1.91915"-->
<!--              y2="13.8184"-->
<!--              gradientUnits="userSpaceOnUse"-->
<!--            >-->
<!--              <stop stop-color="#2A8863" />-->
<!--              <stop offset="0.489" stop-color="#19A56E" />-->
<!--              <stop offset="0.514" stop-color="#15D489" />-->
<!--              <stop offset="0.574" stop-color="#17A970" />-->
<!--              <stop offset="1" stop-color="#08C379" />-->
<!--            </linearGradient>-->
<!--            <linearGradient-->
<!--              id="paint1_linear_6151_1836"-->
<!--              x1="20.7552"-->
<!--              y1="19.9955"-->
<!--              x2="-1.91915"-->
<!--              y2="13.8184"-->
<!--              gradientUnits="userSpaceOnUse"-->
<!--            >-->
<!--              <stop stop-color="#2A8863" />-->
<!--              <stop offset="0.489" stop-color="#19A56E" />-->
<!--              <stop offset="0.514" stop-color="#15D489" />-->
<!--              <stop offset="0.574" stop-color="#17A970" />-->
<!--              <stop offset="1" stop-color="#08C379" />-->
<!--            </linearGradient>-->
<!--          </defs>-->
<!--        </svg>-->
<!--        <div class="text-custom inline-block text-base font-normal leading-snug whitespace-nowrap">-->
<!--          Предложить идею-->
<!--        </div>-->
<!--      </button>-->
    </div>
  </div>
</div>
